import React from 'react';
import './services.css';
import { Link } from 'react-router-dom';
import SectionName from '../section-name/section-name';
import icon1 from '../../assets/icons/icon1.png';
import icon2 from '../../assets/icons/icon2.png';
import icon3 from '../../assets/icons/icon3.png';
import icon4 from '../../assets/icons/icon4.png';
function Services(){
    return(
        <div id='services'>
            <SectionName name="Our Services"/>
            <div className='services-section'>
                <div className="services" data-aos="flip-down">
                    <div className='cards' data-aos="zoom-in-down">
                        <Link to="/services/home-buyers"> 
                            <img src={icon1} alt="icon1" />
                            <h5>Home Buyers</h5>
                            <p>Dedicated support for finding and purchasing residential homes</p>
                        </Link>
                    </div>
                    <div className='cards' data-aos="zoom-in-down">
                        <Link to="/services/land-purchases">
                            <img src={icon3} alt="icon1" />
                            <h5>Land Purchase</h5>
                            <p>Expertise in locating and negotiating prime land options.</p>
                        </Link>
                    </div> 
                    <div className='cards' data-aos="zoom-in-down">
                        <Link to="/services/home-buyers">
                            <img src={icon2} alt="icon1" />
                            <h5>Investment Properties</h5>
                            <p>Tailored guidance for securing lucrative investment opportunities</p>
                        </Link>
                    </div> 
                    <div className='cards' data-aos="zoom-in-down">
                        <Link to="/services/investment-properties">
                            <img src={icon3} alt="icon1" />
                            <h5>Auction & Negotiation</h5>
                            <p>Expert analysis and strategies to secure winning bids and maximize value</p>
                        </Link>
                    </div>  
                </div>
                <div className='btn'>
                    <a target='__blank' className='btn' href="https://calendly.com/buyersgalaxy/30min?month=2024-11">Book a Call</a>
                </div>
            </div>
        </div>
    );
} 
export default Services;
